import Vue from 'vue';
import VueRouter from 'vue-router';

import _ from 'lodash'
import route from './route'
import store from '@/data/store'
import {sspApiNoAdvice} from '@/api';
// import 'vue-lvjs/dist/vue-lvjs.css';
import webUtils from '@/tools/web-utils'

Vue.use(VueRouter);
const router = new VueRouter(route);

export default router;

let interceptor = async function (to, from, next) {
  console.log("router interceptor")
  console.log(to)
  if (['403', '404', 'developerAgreement', 'developerNorms', 'privacyPolicy', 'developerGuide'].includes(to.name)) {
    next()
    return
  }
  let success = true
  await sspApiNoAdvice.getAccount().then((response) => {
  console.log("router interceptor fetch user done" )
    store.commit('setAccountInfo', response);
  })
  .catch((e) => {
    if (to.name !== 'index') {
      if (isUnAuthorized(e)) {
        webUtils.redirect2QxLogin();
        success = false
      }
    }
  });
  // console.log("router interceptor " + success)
  if (success) next()
}

router.beforeEach(interceptor);

function isUnAuthorized(error) {
  let status = _.at(error, 'response.status')[0];
  return status == 401;
}
